import { ZfBox, ZfDivider, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    onReturnToSessions: () => void;
}

export const ReturnToSessions: FunctionComponent<IProps> = ({ onReturnToSessions }) => {
    const { t } = useTranslation();

    const handleButtonClick = () => {
        onReturnToSessions();
    };

    return (
        <ZfBox style={{ display: 'flex', gap: 'var(--gap-vertical-xxs)', alignItems: 'center' }}>
            <ZfBox style={{ height: 36 }}>
                <ZfDivider orientation="vertical" />
            </ZfBox>
            <ZfTextButton size="small" hierarchy="tertiary" trailingIcon="arrow_upward_alt" onClick={handleButtonClick}>
                {t('navReturnToSessions')}
            </ZfTextButton>
        </ZfBox>
    );
};
